<div id="top" class="row w-100 pt-3 text-center row-title">
    <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">Détail de communication</div>
</div>

<div class="mt-4">
    <div class="col-12 text-center">
        @if (reportsForm) {
            <form [formGroup]="reportsForm" (submit)="save()">
                <div class="row">
                    <div class="form-group col-6">
                        <div class="bold-label-text float-left">Date de début<span class="bold-red-text">*</span></div>
                        <mat-form-field>
                            <input
                                    matInput
                                    class="form-control form-full-width"
                                    (dateChange)="handleDate(pickerInput1.value, 'startDate')"
                                    [matDatepicker]="picker1"
                                    #pickerInput1
                            >
                            <mat-datepicker-toggle matSuffix [for]="picker1">
                                <mat-icon id="calendar-icon1" svgIcon="agenda" matDatepickerToggleIcon></mat-icon>
                            </mat-datepicker-toggle>
                            <mat-datepicker #picker1></mat-datepicker>
                        </mat-form-field>
                        @if (reportsFormSubmitted && reportsForm.controls.startDate.errors) {
                            <small class="error-message">{{ getError('startDate') }}</small>
                        }
                    </div>
                    <div class="form-group col-6">
                        <div class="bold-label-text float-left">Date de fin<span class="bold-red-text">*</span></div>
                        <mat-form-field>
                            <input
                                    matInput
                                    class="form-control form-full-width"
                                    (dateChange)="handleDate(pickerInput2.value, 'endDate')"
                                    [matDatepicker]="picker"
                                    #pickerInput2
                            >
                            <mat-datepicker-toggle matSuffix [for]="picker">
                                <mat-icon id="calendar-icon2" svgIcon="agenda" matDatepickerToggleIcon></mat-icon>
                            </mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                        @if (reportsFormSubmitted && reportsForm.controls.endDate.errors) {
                            <small class="error-message">{{ getError('endDate') }}</small>
                        }
                    </div>
                </div>
                @if (errorDate) {
                    <div class="w-100 text-center error-message mb-3">{{ errorDate }}</div>
                }
                <div class="w-100 text-center cta_container">
                    @if (!files || files.data.length == 0) {
                        <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
                    }
                    <button type="submit" class="cta_btn level_2 column">Exporter<span></span></button>
                </div>
            </form>
        }
    </div>
</div>

@if (files && files.data.length > 0) {
    <div>
        <div class="communication-file">
            <div class="row header">
                <div class="col-4">Date</div>
                <div class="col-4">File</div>
                <div class="col-4"></div>
            </div>
            @for (file of files.data; track file) {
                <div class="row gris-background">
                    <div class="col-4">{{ file.date }}</div>
                    <div class="col-4">{{ file.label }}</div>
                    <div class="col-4"><span class="download"
                                             (click)="download(file.id, file.filename)">Télécharger</span></div>
                </div>
            }
        </div>
        <div class="col-12 text-center">
            <div class="w-100 text-center cta_container">
                <button type="button" class="cta_btn level_2 column" (click)="cancel()">Annuler<span></span></button>
            </div>
        </div>
    </div>
}